'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FIXME: Needs to handle assets files to work with SSR
// eslint-disable-next-line @typescript-eslint/no-var-requires
if (require('exenv').canUseDOM) require('./ModalContent.module.css'); /* eslint-disable no-undef */
/* eslint-disable react/prop-types */


var ModalContent = function ModalContent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal--content' },
    children
  );
};

// eslint-disable-next-line react/display-name
ModalContent.Left = function (_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal--content-left' },
    children
  );
};

// eslint-disable-next-line react/display-name
ModalContent.Right = function (_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal--content-right' },
    children
  );
};

exports.default = ModalContent;